<template>
    <div
        class="md-nbr-local classic"
        :style="{ paddingTop, marginBottom }"
        v-if="
            !(
                (countryConfig === 'canada' &&
                    !isOccupancyHasData &&
                    !isCommuteScoreHasData &&
                    !isTemperatureHasData) || isCensusSubdivision
            )
        "
    >
        <module-box
            class="local-content"
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            noPadding
            noMargin
        >
            <nbr-chart
                class="occupancy-chart"
                type="pie"
                :options="occupancyOptions"
                :title="$t('md-nbr-local.occupancy')"
            ></nbr-chart>
            <div class="commute">
                <h2 class="title mg-title">
                    {{ $t('md-nbr-local.commuteScore') }}
                </h2>
                <div class="commute-box">
                    <div class="empty-data" v-show="!dataCommute.length">
                        <site-img
                            src="//cdn.chime.me/image/fs01/agnentinfo/20180305/22/original_5294514866269879.png"
                        >
                        </site-img>
                        <p class="text">{{ $t('md-nbr-local.comingSoon') }}</p>
                    </div>
                    <div v-if="dataCommute.length" class="yaxis">
                        <span>100</span>
                        <span>80</span>
                        <span>60</span>
                        <span>40</span>
                        <span>20</span>
                        <span>0</span>
                    </div>
                    <div v-if="dataCommute.length" class="content">
                        <div
                            v-for="(item, index) in dataCommute"
                            :key="index"
                            class="item"
                            :class="item.class"
                            :style="item.style"
                        >
                            <div class="value-icon">
                                <span class="value">{{ item.value }}</span>
                                <span
                                    class="iconfont"
                                    :class="item.icon"
                                ></span>
                            </div>
                            <span class="name">{{ item.name }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <nbr-chart
                class="temperature-chart"
                type="line"
                :options="temperatureOptions"
                :title="$t('md-nbr-local.temperature')"
            >
            </nbr-chart>
        </module-box>
        <AttomDesc class="mg-container" style="padding-top: 10px;" :size="14" :hasDot="true" />
    </div>
</template>

<script>
import common from '../index';
import nbrChart from '../../../components/nbr-chart/classic.vue';
import { normal } from '../../defaultSpacing.js';
const toolTipStyle = [
    'padding:8px 10px 13px 12px',
    'border-radius:3px',
    'color:rgb(120,120,120)',
    'background-color:#fff',
    'box-shadow: 0 5px 10px rgba(0,0,0,0.2)',
    'font-size:13px',
    'font-family:var(--font-normal)'
].join(';');

const boldStyle = ['color:rgb(40,40,40)', 'line-height: 1'].join(';');

const pStyle = ['color:rgb(120,120,120)', 'margin:6px 0'].join(';');

export default {
    mixins: [common],
    data: function() {
        return {
            ...normal,
            occupancyOptions: null
        };
    },
    methods: {
        setChartData(data) {
            if (data.demographics) {
                const demographics = data.demographics;
                if (demographics.weather) {
                    this.setTemperatureOptions(demographics.weather);
                }
                if (demographics.households) {
                    this.setOccupancyOptions(demographics.households);
                }
            }
            data.walkScore && this.setDataCommute(data.walkScore);
        },
        setOccupancyOptions(data) {
            const colors = ['rgb(0,122,255)', 'rgb(255,169,21)'];
            const seriesData = [
                {
                    name: this.$t('md-nbr-local.owned'),
                    value: data.householdsOccupancyOwned
                },
                {
                    name: this.$t('md-nbr-local.rented'),
                    value: data.householdsOccupancyRented
                }
            ];
            seriesData.map((item, index) => {
                item.itemStyle = {
                    color: colors[index]
                };
                item.emphasis = {
                    itemStyle: {
                        color: colors[index]
                    }
                };
            });
            const baseOption = {
                legend: {
                    formatter: function(name) {
                        var item = seriesData.find(it => it.name === name);
                        if (item) {
                            return (
                                '{a|' +
                                Number(item.value).toFixed(0) +
                                '%}\n{b|' +
                                name +
                                '}'
                            );
                        }
                    },
                    textStyle: {
                        fontSize: 18,
                        padding: [0, 0, 0, 5],
                        rich: {
                            a: {
                                color: '#4b4b4b',
                                fontSize: 18,
                                width: 50,
                                align: 'left'
                            },
                            b: {
                                color: '#787878',
                                fontSize: 13,
                                padding: [0, 0, 0, 0],
                                width: 55,
                                align: 'left'
                            }
                        }
                    }
                },
                series: [
                    {
                        radius: ['50%', '60%'],
                        data: seriesData
                    }
                ]
            };
            this.occupancyOptions = baseOption;
        },
        setTemperatureOptions(data) {
            const baseOption = {
                grid: {
                    left: 70,
                    right: 15,
                    bottom: 65,
                    top: 50,
                    containLabel: false
                },
                tooltip: {
                    padding: 0,
                    formatter: function(param) {
                        return `<div style="${toolTipStyle}">
                            <h3 style="margin: 0 0 6px 0;${boldStyle}">${param[0].name}</h3>
                            <p style="${pStyle}">High:<b style="${boldStyle}"> ${param[0].value} °F</b></p>
                            <p style="${pStyle}">Low:<b style="${boldStyle}"> ${param[1].value} °F</b></p>
                        </div>`;
                    },
                    axisPointer: {
                        lineStyle: {
                            type: 'solid',
                            width: 1,
                            color: 'rgb(232,232,232)'
                        }
                    }
                },
                xAxis: [
                    {
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgb(236,236,236)'
                            }
                        },
                        axisLabel: {
                            color: 'rgb(120,120,120)'
                        },
                        data: [
                            this.$t('md-nbr-local.jan'),
                            this.$t('md-nbr-local.apr'),
                            this.$t('md-nbr-local.jul'),
                            this.$t('md-nbr-local.oct')
                        ]
                    }
                ],
                yAxis: [
                    {
                        axisLabel: {
                            formatter: '{value} °F',
                            color: 'rgb(120,120,120)'
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgb(236,236,236)'
                            }
                        },
                        splitArea: {
                            show: false
                        },
                        offset: 0
                    }
                ],
                series: [
                    {
                        type: 'line',
                        showSymbol: true,
                        symbolSize: 10,
                        symbol: 'emptyCircle',
                        itemStyle: {
                            normal: {
                                color: 'rgb(0,122,255)',
                                borderColor: 'rgb(0,122,255)',
                                borderWidth: 3
                            }
                        },
                        lineStyle: {
                            normal: {
                                width: 3
                            }
                        },
                        data: [
                            Number(data.weatherJanHigh),
                            Number(data.weatherAprHigh),
                            Number(data.weatherJulHigh),
                            Number(data.weatherOctHigh)
                        ]
                    },
                    {
                        type: 'line',
                        showSymbol: true,
                        symbolSize: 10,
                        symbol: 'emptyCircle',
                        itemStyle: {
                            normal: {
                                color: 'rgb(7,211,91)',
                                borderColor: 'rgb(7,211,91)',
                                borderWidth: 3
                            }
                        },
                        lineStyle: {
                            normal: {
                                width: 3
                            }
                        },
                        data: [
                            Number(data.weatherJanLow),
                            Number(data.weatherAprLow),
                            Number(data.weatherJulLow),
                            Number(data.weatherOctLow)
                        ]
                    }
                ]
            };
            const chartOption = {
                baseOption,
                media: [
                    {
                        query: {
                            maxWidth: 600
                        },
                        option: {
                            grid: {
                                left: 70,
                                right: 15,
                                bottom: 65,
                                top: 50
                            }
                        }
                    }
                ]
            };
            this.temperatureOptions = chartOption;
        },
        setDataCommute(data) {
            const dataCommute = [];
            const commuteObj = {
                walk: {
                    value: data.walkscore,
                    name: this.$t('md-nbr-local.walk'),
                    class: 'walk',
                    icon: 'icon-walk',
                    style: {
                        height:
                            (data.walkscore > 15 ? data.walkscore : 15) + '%'
                    }
                },
                bike: {
                    value: data.bikescore,
                    name: this.$t('md-nbr-local.bike'),
                    class: 'bike',
                    icon: 'icon-bike',
                    style: {
                        height:
                            (data.bikescore > 15 ? data.bikescore : 15) + '%'
                    }
                },
                transit: {
                    value: data.transitscore,
                    name: this.$t('md-nbr-local.publicTransit'),
                    class: 'transit',
                    icon: 'icon-transit',
                    style: {
                        height:
                            (data.transitscore > 15 ? data.transitscore : 15) +
                            '%'
                    }
                }
            };
            for (let key in commuteObj) {
                const item = commuteObj[key];
                if (item.value) {
                    this.maxCommute =
                        item.value > this.maxCommute
                            ? item.value
                            : this.maxCommute;
                    dataCommute.push(item);
                }
            }
            this.dataCommute = dataCommute;
        }
    },
    components: {
        nbrChart
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';

.md-nbr-local.classic {
    width: 100%;
    background-color: #ffffff;
    .local-content {
        display: flex;
        justify-content: space-between;
        .occupancy-chart {
            width: calc(33% - 20px);
            display: block;
            .chart-box {
                width: 100%;
                height: 400px;
                border-radius: 2px;
                border: 1px solid #e5ebf1;
            }
        }
        .commute {
            width: calc(33% - 20px);
            .title {
                line-height: 1.2;
                padding-bottom: 20px;
            }
            .commute-box {
                position: relative;
                width: 100%;
                height: 400px;
                border-radius: 2px;
                border: 1px solid #e5ebf1;
                display: flex;
                justify-content: center;
                .empty-data {
                    z-index: 1;
                    position: absolute;
                    max-width: 50%;
                    width: 219px;
                    height: auto;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    img {
                        width: 100%;
                    }
                    .text {
                        text-align: center;
                        margin-top: 15px;
                        color: #c8c8c8;
                    }
                }
                .yaxis {
                    width: 30px;
                    height: 100%;
                    padding: 70px 0 62px 0;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    span {
                        font-size: 13px;
                        text-align: right;
                        line-height: 30px;
                        color: #787878;
                    }
                }
                .content {
                    width: 258px;
                    max-width: calc(100% - 60px);
                    height: 268px;
                    margin-top: 70px;
                    margin-left: 10px;
                    position: relative;
                    display: flex;
                    justify-content: space-around;
                    align-items: flex-end;
                    .item {
                        width: 50px;
                        position: relative;
                        border-radius: 2px;
                        max-height: 100%;
                        &.walk {
                            background-color: #5a7896;
                            color: #5a7896;
                        }
                        &.bike {
                            background-color: #007aff;
                            color: #007aff;
                        }
                        &.transit {
                            background-color: #ffa90f;
                            color: #ffa90f;
                        }
                        .value-icon {
                            position: absolute;
                            bottom: 100%;
                            width: 100%;
                            left: 0;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            .value {
                                font-size: 20px;
                            }
                            .iconfont {
                                font-size: 26px;
                            }
                        }
                        .name {
                            color: #787878;
                            font-size: 13px;
                            line-height: 30px;
                            position: absolute;
                            bottom: -36px;
                            width: 80px;
                            text-align: center;
                            left: -15px;
                            white-space: nowrap;
                        }
                    }
                    &::before {
                        content: '';
                        position: absolute;
                        width: 1px;
                        height: 277px;
                        left: 0;
                        bottom: 0;
                        background-color: #ececec;
                    }
                    &::after {
                        content: '';
                        position: absolute;
                        width: 100%;
                        height: 1px;
                        left: 0;
                        bottom: 0;
                        background-color: #ececec;
                    }
                }
            }
        }
        .temperature-chart {
            width: calc(33% - 20px);
            display: block;
            .chart-box {
                width: 100%;
                height: 400px;
                border-radius: 2px;
                border: 1px solid #e5ebf1;
            }
        }
    }
    @include media-1080 {
        .local-content {
            .occupancy-chart,
            .commute,
            .temperature-chart {
                width: calc(33% - 10px);
            }
        }
    }
    @include media-800 {
        padding-top: 0;
        .local-content {
            flex-direction: column;
            .occupancy-chart {
                width: 100%;
            }
            .commute {
                width: 100%;
                margin-top: 30px;
            }
            .temperature-chart {
                width: 100%;
                margin-top: 30px;
            }
        }
    }
    @include media-600 {
        .local-content {
            .occupancy-chart .chart-box {
                height: 390px;
            }
        }
    }
}
</style>
